var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#182F43",
    stroke: "#182F43",
    strokeWidth: 0.5,
    d: "M3.75 16.75h16.5a.5.5 0 0 1 0 1H3.75a.5.5 0 0 1 0-1Zm0-5.25h12.5a.5.5 0 0 1 0 1H3.75a.5.5 0 0 1 0-1Zm0-5.25h16.5a.5.5 0 0 1 0 1H3.75a.5.5 0 0 1 0-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3df9369101da9cff0eaacc673e50a1f8.svg";
export { ForwardRef as ReactComponent };